// The mock preview signs in with this token (store/auth.ts, BUN_PUBLIC_USE_MOCKS=true).
export const MOCK_TOKEN = "mock";
